<template>
<footer class="bg-gray-200">

    <div class="flex justify-center items-start text-sm py-4">
        <div class="flex flex-col px-3">
            <a href="https://www.bdew.de/impressum/" target="_blank">
                Impressum
            </a>
            <router-link to="/privacy">
                Datenschutz
            </router-link>
            <router-link to="/terms-of-use">
                Nutzungsbedingungen
            </router-link>
        </div>

        <div class="flex flex-col px-3">
            <router-link to="/contact">
                Kontakt
            </router-link>
            <!--
            <router-link to="webinar">
                Webinar
            </router-link>
            -->
            <a href="https://bdew-webinare.webex.com/recordingservice/sites/bdew-webinare/recording/2851dbdf85ab4260ba620f3d4839712b/playback" target="_blank">
                Webinar
            </a>
            <a href="https://www.bdew.de/" target="_blank">
                Webseite des BDEW
            </a>
        </div>
        <div class="flex flex-col px-3">
            <a href="https://www.bdew.de/rechtliches/" target="_blank">Rechtliches</a>
            <router-link to="/redaktion">
                Redaktion
            </router-link>
            <router-link to="/changelogs">
                Changelog
            </router-link>
        </div>
    </div>
    <div class="friendventure border-t border-gray-400 px-2 text-center">
        Die Daten des zugrunde liegenden BDEW-Heizkostenvergleichs werden mit diesem Tool individualisiert.
    </div>
</footer>
</template>

<script>
export default {}
</script>

<style scoped>

.friendventure {

    padding: 36px 0;
    font-size: 16px;
}
.friendventure-ref {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 1.25;
    color: #787878;
}

.friendventure-logo {
    height: 17px;
    margin: 0 5px;
    width: 26px;
}
</style>
